import { useEffect } from "react";

import {
    broadcastMessage,
    Message
} from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const useUrlErrorMessage = (message: Omit<Message, "text">) => {
    const { t } = useGranite();

    useEffect(() => {
        const errorMessageId = new URL(window.location.href).searchParams.get(
            "ci-m"
        );

        const errorMessage = t(`apiMessages.title.${errorMessageId}`);
        if (!errorMessage) return;

        broadcastMessage({
            text: errorMessage,
            ...message
        });
    }, [message, t]);
};
